var chunkToChildrenMap = {
	"7": [
		636
	],
	"142": [
		636
	],
	"621": [
		636,
		334,
		104,
		639,
		716
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };